@if (item?.content?.length) {
  <div class="container">
    @for (subitem of $any(item.content); track subitem) {
      <coin-equity-cms-card-item
        [modifiedWidth]="modifiedWidth"
        [card]="subitem"
        [contentEdit]="contentEdit"
        [small]="$any(item).small"></coin-equity-cms-card-item>
    }
  </div>
}

@if (contentEdit && item) {
  <div>
    <mat-form-field appearance="fill">
      <mat-label>{{ 'cms.amount-cards' | translate }}</mat-label>
      <mat-select
        [(ngModel)]="amountCards"
        (selectionChange)="amountChange($event.value)">
        @for (option of amountOptions; track option) {
          <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <coin-v2-checkbox
      [label]="'cms.content-pages.small-image' | translate"
      [(ngModel)]="item['small']" />
    <coin-v2-checkbox
      [label]="'cms.content-pages.requires-authentication' | translate"
      [(ngModel)]="item.requiresAuthentication"></coin-v2-checkbox>
  </div>
}
